(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-size-calculator"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-image-size-calculator]').forEach((calculator) => {
    if (calculator.dataset.initialized === 'true') return;
    calculator.dataset.initialized = 'true';

    const widthInput = calculator.querySelector('[data-calculator-width]');
    const heightInput = calculator.querySelector('[data-calculator-height]');
    const widthResult = calculator.querySelector('[data-calculator-width-result]');
    const heightResult = calculator.querySelector('[data-calculator-height-result]');
    const shapeResult = calculator.querySelector('[data-calculator-shape]');
    const matchResult = calculator.querySelector('.pp-image-calculator__match');
    const recommendation = calculator.querySelector('[data-calculator-link]');
    const pixelsPerInch = 110;

    const categories = {
      square: {
        label: calculator.dataset.squareLabel,
        linkLabel: calculator.dataset.squareLinkLabel,
        href: '/collections/non-panoramic-products'
      },
      nonPanoramic: {
        label: calculator.dataset.nonPanoramicLabel,
        linkLabel: calculator.dataset.nonPanoramicLinkLabel,
        href: '/collections/non-panoramic-products'
      },
      panoramic: {
        label: calculator.dataset.panoramicLabel,
        linkLabel: calculator.dataset.panoramicLinkLabel,
        href: '/collections/panoramic-products'
      },
      ultraPanoramic: {
        label: calculator.dataset.ultraPanoramicLabel,
        linkLabel: calculator.dataset.ultraPanoramicLinkLabel,
        href: '/collections/ultra-panoramic-products'
      }
    };

    function updateCalculator() {
      const width = Math.max(0, Number.parseInt(widthInput.value, 10) || 0);
      const height = Math.max(0, Number.parseInt(heightInput.value, 10) || 0);

      widthResult.value = String(Math.round(width / pixelsPerInch));
      heightResult.value = String(Math.round(height / pixelsPerInch));

      if (!width || !height) {
        shapeResult.textContent = '';
        matchResult.hidden = true;
        recommendation.hidden = true;
        return;
      }

      const aspectRatio = Math.max(width, height) / Math.min(width, height);
      let category = categories.square;

      if (aspectRatio > 7 / 6) category = categories.nonPanoramic;
      if (aspectRatio > 13 / 6) category = categories.panoramic;
      if (aspectRatio > 3.8) category = categories.ultraPanoramic;

      shapeResult.textContent = category.label;
      matchResult.hidden = false;
      recommendation.textContent = category.linkLabel;
      recommendation.href = category.href;
      recommendation.hidden = false;
    }

    widthInput.addEventListener('input', updateCalculator);
    heightInput.addEventListener('input', updateCalculator);
    updateCalculator();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
if (!customElements.get('pp-cart-chat-guard')) {
  customElements.define('pp-cart-chat-guard', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.pp-cart-hybrid');
      const checkout = this.root?.querySelector('.cart-recap button[name="checkout"]');
      if (!checkout || !('IntersectionObserver' in window)) return;

      this.sticky = this.root.querySelector('.pp-cart-sticky');
      const stickyButton = this.sticky?.querySelector('button[name="checkout"]');
      if (this.sticky && stickyButton) {
        this.syncButton = () => {
          stickyButton.disabled = checkout.disabled;
          stickyButton.setAttribute('aria-disabled', String(checkout.disabled));
        };
        this.syncButton();
        this.buttonObserver = new MutationObserver(this.syncButton);
        this.buttonObserver.observe(checkout, { attributes: true, attributeFilter: ['disabled'] });
        this.root.setAttribute('data-pp-sticky-ready', '');
        if ('ResizeObserver' in window) {
          this.sizeObserver = new ResizeObserver(() => {
            const height = this.sticky.getBoundingClientRect().height;
            if (height > 0) document.documentElement.style.setProperty('--pp-cart-sticky-height', `${Math.ceil(height)}px`);
          });
          this.sizeObserver.observe(this.sticky);
        }
      }

      this.observer?.disconnect();
      this.observer = new IntersectionObserver((entries) => {
        if (!this.isConnected) return;
        this.root.toggleAttribute('data-pp-checkout-visible', entries.some(entry => entry.isIntersecting));
      }, { rootMargin: '24px 0px', threshold: 0 });
      this.observer.observe(checkout);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.sizeObserver?.disconnect();
      this.buttonObserver?.disconnect();
      this.root?.removeAttribute('data-pp-checkout-visible');
      this.root?.removeAttribute('data-pp-sticky-ready');
      document.documentElement.style.removeProperty('--pp-cart-sticky-height');
      this.observer = null;
      this.sizeObserver = null;
      this.buttonObserver = null;
      this.sticky = null;
      this.syncButton = null;
      this.root = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-canvas-size"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('pp-canvas-size')) {
 customElements.define('pp-canvas-size', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort(); this.controller = new AbortController();
   this.options = [...this.querySelectorAll('[data-size-option]')];
   if (!this.options.length) return;
   this.remembered = {};
   const initial = this.options.find(el => el.querySelector('input').checked) || this.options[0];
   this.remembered[initial.dataset.group] = initial;
   this.selectShape(initial.dataset.group);
   this.addEventListener('change', event => {
    if (event.target.matches('[data-shape]')) this.selectShape(event.target.value);
    if (event.target.matches('[data-size]')) this.selectSize(event.target.closest('[data-size-option]'));
   }, {signal:this.controller.signal});
   this.addEventListener('shopify:block:select', event => {
    const option=this.options.find(el=>el.dataset.blockId===event.detail.blockId);
    if(option){this.remembered[option.dataset.group]=option;this.selectShape(option.dataset.group);}
   }, {signal:this.controller.signal});
  }
  disconnectedCallback(){this.controller?.abort();}
  selectShape(group) {
   const available=this.options.filter(el=>el.dataset.group===group);
   if(!available.length)return;
   this.querySelectorAll('[data-shape]').forEach(input=>{
    input.checked=input.value===group;
    input.closest('label').hidden=!this.options.some(el=>el.dataset.group===input.value);
   });
   this.options.forEach(el=>{el.hidden=el.dataset.group!==group;el.querySelector('input').disabled=el.hidden;});
   this.selectSize(this.remembered[group]||available[Math.min(2,available.length-1)]);
  }
  selectSize(option) {
   if(!option)return;
   const d=option.dataset,w=Number(d.width),h=Number(d.height);
   if(!(w>0&&h>0))return;
   this.remembered[d.group]=option;
   this.options.forEach(el=>el.querySelector('input').checked=el===option);
   const width=(w/(Number(this.dataset.sofaWidth)||220)*(Number(this.dataset.sofaSpan)||60))+'%';
   this.querySelector('.cs__canvas').style.setProperty('--canvas-width',width);
   this.querySelector('.cs__canvas').style.setProperty('--canvas-ratio',w+' / '+h);
   this.querySelector('.cs__width').style.setProperty('--canvas-width',width);
   this.querySelector('[data-width-text]').textContent=this.dataset.widthLabel.replace('__WIDTH__',w);
   this.querySelector('[data-category-text]').textContent=d.category;
   this.querySelector('[data-title]').textContent=d.heading;
   this.querySelector('[data-description]').textContent=d.body;
   this.querySelectorAll('[data-product-link]').forEach(link=>link.hidden=link.dataset.productLink!==d.blockId);
  }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-cinematic-hero"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('pp-cinematic-hero')){
    customElements.define('pp-cinematic-hero',class extends HTMLElement{
      connectedCallback(){
        if(this.controller)return;
        this.controller=new AbortController();const options={signal:this.controller.signal};
        this.stage=this.querySelector('.ppch-stage');this.opening=this.querySelector('.ppch-opening');this.full=this.querySelector('.ppch-full');this.panorama=this.querySelector('.ppch-panorama');this.room=this.querySelector('.ppch-room');this.product=this.querySelector('.ppch-product');this.print=this.querySelector('.ppch-print');this.surface=this.querySelector('.ppch-surface');this.range=this.querySelector('.ppch-progress');this.play=this.querySelector('.ppch-play');this.chapters=[...this.querySelectorAll('[data-progress]')];this.p=0;this.target=0;this.playing=false;this.currentChapter=-1;
        this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.reduced.addEventListener('change',()=>this.configure(),options);
        this.onScroll=()=>{if(!this.active)return;this.target=this.clamp((window.scrollY-this.start)/this.distance);this.wake()};
        window.addEventListener('scroll',this.onScroll,{...options,passive:true});
        this.stop=()=>{this.playing=false;this.play.textContent=this.p>.99?this.dataset.replay:this.dataset.watch};
        window.addEventListener('wheel',this.stop,{...options,passive:true});window.addEventListener('touchstart',this.stop,{...options,passive:true});window.addEventListener('keydown',e=>{if(['PageDown','PageUp','ArrowDown','ArrowUp','Home','End','Escape'].includes(e.key))this.stop()},options);
        this.play.addEventListener('click',()=>{if(this.playing){this.stop();return}if(this.p>.98){this.seek(0);this.p=0;this.render()}this.playing=true;this.play.textContent=this.dataset.pause;this.wake()},options);
        this.range.addEventListener('input',()=>{this.stop();this.seek(Number(this.range.value)/1000)},options);
        this.chapters.forEach(button=>button.addEventListener('click',()=>{this.stop();this.seek(Number(button.dataset.progress))},options));
        document.addEventListener('visibilitychange',()=>{if(document.hidden)this.stop()},options);
        this.resize=new ResizeObserver(()=>this.measure());this.resize.observe(this.stage);
        this.configure();
        // Decode the print before it is revealed, without delaying the opening photo.
        [this.print,this.panorama].forEach(img=>{img.loading='eager';if(img.decode)img.decode().catch(()=>{})});
        document.fonts?.ready.then(()=>{if(this.isConnected)this.measure()});
      }
      disconnectedCallback(){this.controller?.abort();this.resize?.disconnect();cancelAnimationFrame(this.raf);this.controller=null}
      clamp(n){return Math.max(0,Math.min(1,n))}
      mix(a,b,t){return a+(b-a)*t}
      ease(t){t=this.clamp(t);return t*t*t*(t*(6*t-15)+10)}
      curve(t,points){const n=points.length;if(t<=points[0][0])return points[0][1];if(t>=points[n-1][0])return points[n-1][1];const slopes=points.slice(1).map((p,i)=>(p[1]-points[i][1])/(p[0]-points[i][0]));const m=points.map((_,i)=>{if(!i||i===n-1)return 0;const a=slopes[i-1],b=slopes[i];return a*b<=0?0:2*a*b/(a+b)});let i=0;while(t>points[i+1][0])i++;const h=points[i+1][0]-points[i][0],u=(t-points[i][0])/h,u2=u*u,u3=u2*u;return(2*u3-3*u2+1)*points[i][1]+(u3-2*u2+u)*h*m[i]+(-2*u3+3*u2)*points[i+1][1]+(u3-u2)*h*m[i+1]}
      configure(){this.active=this.dataset.motion==='true'&&!this.reduced.matches;this.classList.toggle('ppch-ready',this.active);this.querySelector('.ppch-controls').hidden=!this.active;this.stop();this.measure();if(!this.active){this.p=0;this.target=0;this.render()}}
      measure(){
        const r=this.stage.getBoundingClientRect();this.w=r.width;this.h=r.height;this.mobile=this.w<750;this.copyTop=this.querySelector('.ppch-copy').offsetTop;
        this.start=this.getBoundingClientRect().top+window.scrollY-parseFloat(getComputedStyle(this.stage).top||0);
        if(!Number.isFinite(this.start))this.start=this.getBoundingClientRect().top+window.scrollY;
        this.distance=Math.max(1,this.offsetHeight-this.h);
        const w=this.w,h=this.h,unit=h/8,world=w/unit,u=6/1816,outer=1850*u,outerH=(1816/3+34)*u;
        const rw=this.mobile?world:Math.min(8*1672/941,world*1.4),rh=rw*(this.mobile?1672/941:941/1672),end=rw*(this.mobile?.585:.4919940565)/outer;
        const bias=this.mobile?Math.max(0,(.32+.345*rh+outerH*end/2)*unit+18-this.copyTop)/unit:0,rt=this.mobile?.32-bias:(8-rh)/2;
        this.geometry={unit,world,u,outer,outerH,end,bias,wallY:4-rt-.345*rh,mid:Math.max(world*(this.mobile?.82:.58)/outer,end*1.1),start:world/6*1.015,initialW:Math.max(w,h*6000/4004)};
        // Layout is fixed here. Scroll frames change only transforms, clips and composited appearance.
        Object.assign(this.room.style,{width:`${rw*unit}px`,height:`${rh*unit}px`,left:`${(w-rw*unit)/2}px`,top:`${rt*unit}px`});
        Object.assign(this.product.style,{width:`${outer*unit}px`,height:`${outerH*unit}px`,borderWidth:`${12*u*unit}px`,padding:`${5*u*unit}px`,boxShadow:`${2*u*unit}px ${3*u*unit}px ${7*u*unit}px rgba(0,0,0,.34),${18*u*unit}px ${12*u*unit}px ${28*u*unit}px rgba(0,0,0,.25),inset 0 0 1px #857867`});
        Object.assign(this.opening.style,{inset:'0',width:'100%',height:'100%'});
        Object.assign(this.full.style,{width:`${this.geometry.initialW}px`,height:`${this.geometry.initialW/(6000/4004)}px`,left:'0',top:'0',objectFit:'fill'});
        Object.assign(this.panorama.style,{width:`${6*unit}px`,height:`${2*unit}px`});
        this.onScroll();this.render();
      }
      seek(p){this.target=this.clamp(p);window.scrollTo({top:this.start+this.distance*this.target,behavior:'instant'});this.wake()}
      wake(){if(!this.raf){this.last=performance.now();this.raf=requestAnimationFrame(t=>this.tick(t))}}
      tick(t){this.raf=0;if(!this.active)return;const dt=Math.min(.05,(t-this.last)/1000);this.last=t;if(this.playing){this.target=this.clamp(this.target+dt/9);window.scrollTo({top:this.start+this.distance*this.target,behavior:'instant'});if(this.target>=1)this.stop()}this.p=this.mix(this.p,this.target,1-Math.exp(-dt/.18));if(Math.abs(this.p-this.target)<.0001)this.p=this.target;this.render();if(this.playing||Math.abs(this.p-this.target)>.0001)this.raf=requestAnimationFrame(time=>this.tick(time))}
      render(){
        if(!this.geometry)return;
        const p=this.p,w=this.w,h=this.h,{unit,bias,wallY,mid,start,end,initialW}=this.geometry;
        const scale=Math.exp(this.curve(p,[[0,Math.log(start)],[.08,Math.log(start*.998)],[.4,Math.log(mid*1.12)],[.66,Math.log(mid)],[1,Math.log(end)]]));
        const x=this.curve(p,[[0,0],[.2,0],[.62,this.mobile?.04:.16],[1,0]]),y=this.curve(p,[[0,0],[.08,.02],[.4,1.25+bias+(this.mobile?.35:0)],[.66,1.2+bias+(this.mobile?.25:0)],[1,wallY]]);
        const rx=this.curve(p,[[0,0],[.52,0],[.67,.13],[.8,.06],[1,0]]),ry=this.curve(p,[[0,0],[.52,0],[.67,-.34],[.8,-.18],[1,0]]),rz=this.curve(p,[[0,0],[.52,0],[.67,-.023],[.82,-.007],[1,0]]);
        const room=this.ease((p-.66)/.34),material=this.ease((p-.52)/.22),morph=this.ease((p-.015)/.335),photoBlend=this.ease((p-.35)/.08),frameReveal=this.ease((p-.38)/.06),handoff=this.ease((p-.44)/.08),pu=scale*unit;
        this.room.style.opacity=room;
        this.product.style.transform=`translate(-50%,-50%) translate3d(${x*unit}px,${-y*unit}px,0) rotateX(${-rx}rad) rotateY(${-ry}rad) rotateZ(${-rz}rad) scale(${scale})`;
        this.product.style.opacity=frameReveal;
        this.print.style.filter=`brightness(${this.mix(1,.68,material)}) saturate(${this.mix(1,.84,material)}) contrast(${this.mix(1,.96,material)})`;this.surface.style.opacity=material;
        const pw=6*pu,ph=2*pu,ow=this.mix(w,pw,morph),oh=this.mix(h,ph,morph),cx=this.mix(w/2,w/2+x*unit,morph),cy=this.mix(h/2,h/2-y*unit,morph),ratio=6000/4004,iw=this.mix(initialW,pw*(.9*6000/6820),morph);
        const fx=this.mix((w-initialW)*(this.mobile?.61:.5),w/2+x*unit-pw/2+pw*(340/6820),morph),fy=this.mix((h-initialW/ratio)*.42,h/2-y*unit-ph/2-ph*(400/2273),morph);
        this.opening.style.clipPath=`inset(${cy-oh/2}px ${w-cx-ow/2}px ${h-cy-oh/2}px ${cx-ow/2}px)`;
        this.opening.style.opacity=1-handoff;this.opening.style.visibility=handoff===1?'hidden':'visible';
        this.full.style.transform=`translate3d(${fx}px,${fy}px,0) scale(${iw/initialW})`;this.full.style.opacity=1-photoBlend;
        this.panorama.style.transform=`translate(-50%,-50%) translate3d(${cx-w/2}px,${cy-h/2}px,0) scale(${Math.max(ow/(6*unit),oh/(2*unit))})`;
        this.range.value=Math.round((document.activeElement===this.range?this.target:p)*1000);
        const active=p<.38?0:p<.82?1:2;
        if(active!==this.currentChapter){this.currentChapter=active;this.chapters.forEach((b,i)=>{if(i===active)b.setAttribute('aria-current','step');else b.removeAttribute('aria-current')})}
        this.dataset.progress=p.toFixed(4);
        if(!this.playing){const label=p>.99?this.dataset.replay:this.dataset.watch;if(this.play.textContent!==label)this.play.textContent=label}
      }

    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-collection-editorial"]) return;
  try {
    
  if (!customElements.get('pp-collection-editorial')) {
    customElements.define('pp-collection-editorial', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const filters = this.querySelector('.pp-collection__filters');
        if (filters) {
          const available = new Set([...this.querySelectorAll('[data-category]')].map(card => card.dataset.category));
          filters.querySelectorAll('[data-filter]').forEach(button => {
            button.hidden = button.dataset.filter !== 'all' && !available.has(button.dataset.filter);
          });
          filters.hidden = available.size < 2;
          filters.addEventListener('click', event => {
            const button = event.target.closest('[data-filter]');
            if (!button) return;
            const cards = [...this.querySelectorAll('[data-category]')];
            cards.forEach(card => { card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter; });
            filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            const count = this.querySelector('[data-product-count]');
            const visibleCount = cards.filter(card => !card.hidden).length;
            count.textContent = (visibleCount === 1 ? this.dataset.singleProduct : count.dataset.countTemplate).replace('__COUNT__', visibleCount);
          });
        }
        const content = this.querySelector('.pp-collection__seo .metafield-rich_text_field');
        if (content && content.querySelector('h2') && content.querySelector('h3')) {
          const intro = document.createElement('div');
          intro.className = 'pp-collection__seo-intro';
          const topics = document.createElement('div');
          let group = intro;
          [...content.children].forEach(child => {
            if (child.tagName === 'H3') {
              group = document.createElement('section');
              group.className = 'pp-collection__seo-topic';
              topics.append(group);
            }
            group.append(child);
          });
          content.classList.add('pp-collection__seo-layout');
          content.append(intro, topics);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-faq-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-faq-page')) {
    customElements.define('pp-faq-page', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        this.search = this.querySelector('[data-faq-search]');
        this.questions = [...this.querySelectorAll('[data-faq-question]')];
        this.groups = [...this.querySelectorAll('[data-faq-group]')];
        this.beforeSearch = null;
        this.index = new Map(this.questions.map(q => [q,this.words(q.textContent+' '+q.dataset.faqKeywords).join(' ')]));
        this.querySelectorAll('[data-faq-enhanced]').forEach(el => el.hidden = false);
        this.querySelectorAll('[data-faq-topic-link]').forEach(link => {
          const group = this.groups.find(group => group.dataset.faqTopic === link.dataset.faqTopicLink);
          const count = group?.querySelectorAll('[data-faq-question]').length || 0;
          link.querySelector('[data-faq-topic-count]').textContent = String(count).padStart(2,'0');
          link.hidden = count === 0;
        });
        this.querySelectorAll('[data-faq-jump]').forEach(link => {
          if (link.closest('.pp-faq__popular')) link.hidden = !this.findTarget(link.hash);
        });
        this.search.addEventListener('input', () => this.filter(true), options);
        this.addEventListener('click', event => {
          const reset = event.target.closest('[data-faq-clear],[data-faq-reset]');
          if (reset) { this.clear(); this.search.focus(); return; }
          const link = event.target.closest('[data-faq-jump]');
          if (!link) return;
          const target = this.findTarget(link.hash);
          if (!target) return;
          event.preventDefault();
          this.clear();
          this.reveal(target,true);
          if (!window.Shopify?.designMode) history.replaceState(null,'',link.hash);
        },options);
        window.addEventListener('hashchange', () => this.followHash(),options);
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          this.clear();
          const target = event.target.closest('[data-faq-question],[data-faq-group]') || event.target;
          this.reveal(target,true);
        },options);
        this.filter(false);
        this.followHash();
      }
      disconnectedCallback() { this.controller?.abort(); }
      words(value) {
        const synonyms = {shipping:'delivery',images:'photo',image:'photo',photos:'photo',colors:'colours',color:'colour',refunds:'refund'};
        return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[’']/g,'').split(/[^a-z0-9]+/).filter(Boolean).map(word => synonyms[word] || word);
      }
      filter(expand) {
        const terms = this.words(this.search.value);
        if (terms.length && expand && !this.beforeSearch) this.beforeSearch = new Set(this.questions.filter(q=>q.open));
        if (!terms.length && this.beforeSearch) { this.questions.forEach(q => q.open=this.beforeSearch.has(q)); this.beforeSearch=null; }
        let count=0;
        this.questions.forEach(q => { const hit=terms.every(term=>this.index.get(q).includes(term));q.hidden=!hit;if(hit)count++;if(hit&&terms.length&&expand)q.open=true; });
        this.groups.forEach(group => group.hidden=![...group.querySelectorAll('[data-faq-question]')].some(q=>!q.hidden));
        this.querySelector('[data-faq-status]').textContent=(terms.length?this.dataset.resultsLabel:this.dataset.allLabel).replace('__COUNT__',String(count)).replace('__QUERY__',this.search.value);
        this.querySelector('[data-faq-clear]').hidden=!this.search.value;
        this.querySelector('[data-faq-empty]').hidden=count>0;
      }
      clear() { this.search.value='';this.filter(false); }
      findTarget(hash) { if(!hash||hash.charAt(0)!=='#')return null;let id;try{id=decodeURIComponent(hash.slice(1))}catch{return null}return [...this.querySelectorAll('[id]')].find(el=>el.id===id)||null; }
      reveal(target,scroll) { if(target.matches('details'))target.open=true;if(scroll){target.scrollIntoView({block:'start',behavior:'auto'});if(target.matches('details'))target.querySelector('summary').focus({preventScroll:true});} }
      followHash() { const target=this.findTarget(location.hash);if(target){this.clear();this.reveal(target,true);} }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-floating-collection"]) return;
  try {
    
  if (!customElements.get('pp-collection-editorial')) {
    customElements.define('pp-collection-editorial', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const filters = this.querySelector('.pp-collection__filters');
        if (filters) {
          const available = new Set([...this.querySelectorAll('[data-category]')].map(card => card.dataset.category));
          filters.querySelectorAll('[data-filter]').forEach(button => {
            button.hidden = button.dataset.filter !== 'all' && !available.has(button.dataset.filter);
          });
          filters.hidden = available.size < 2;
          filters.addEventListener('click', event => {
            const button = event.target.closest('[data-filter]');
            if (!button) return;
            const cards = [...this.querySelectorAll('[data-category]')];
            cards.forEach(card => { card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter; });
            filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            const count = this.querySelector('[data-product-count]');
            const visibleCount = cards.filter(card => !card.hidden).length;
            count.textContent = (visibleCount === 1 ? this.dataset.singleProduct : count.dataset.countTemplate).replace('__COUNT__', visibleCount);
          });
        }
        const content = this.querySelector('.pp-collection__seo .metafield-rich_text_field');
        if (content && content.querySelector('h2') && content.querySelector('h3')) {
          const intro = document.createElement('div');
          intro.className = 'pp-collection__seo-intro';
          const topics = document.createElement('div');
          let group = intro;
          [...content.children].forEach(child => {
            if (child.tagName === 'H3') {
              group = document.createElement('section');
              group.className = 'pp-collection__seo-topic';
              topics.append(group);
            }
            group.append(child);
          });
          content.classList.add('pp-collection__seo-layout');
          content.append(intro, topics);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-frame-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-frame-comparison')) {
  customElements.define('pp-frame-comparison', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-colour]');
        if (button && this.contains(button)) this.selectColour(button);
        const trigger = event.target.closest('[data-frame-dialog]');
        if (trigger && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
          const dialog = this.querySelector('#' + CSS.escape(trigger.dataset.frameDialog));
          if (dialog && typeof dialog.showModal === 'function') {
            event.preventDefault();
            dialog.returnFocus = trigger;
            dialog.showModal();
            dialog.scrollTop = 0;
          }
        }
        const close = event.target.closest('[data-frame-dialog-close]');
        if (close) close.closest('dialog').close();
        if (event.target instanceof HTMLDialogElement) {
          const rect = event.target.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
        }
      }, { signal });
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const controls = Array.from(dialog.querySelectorAll('a[href], button:not([disabled])')).filter(element => element.getClientRects().length);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, { signal });
        dialog.addEventListener('close', () => {
          if (dialog.returnFocus?.isConnected) dialog.returnFocus.focus({ preventScroll: true });
        }, { signal });
      });
      this.addEventListener('shopify:block:select', event => {
        const button = event.target.closest('[data-colour]');
        if (button) this.selectColour(button);
        const details = event.target.closest('details');
        if (details) details.open = true;
      }, { signal });
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    }
    selectColour(button) {
      this.style.setProperty('--compare-frame', button.dataset.colourValue);
      this.style.setProperty('--compare-frame-edge', button.dataset.edge);
      this.querySelectorAll('[data-colour]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      this.querySelector('[data-colour-label]').textContent = button.dataset.colour;
      this.querySelector('[data-comparison-status]').textContent = this.dataset.announcement.replace('__COLOUR__', button.dataset.colour);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-hangtiles-layouts"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-hangtiles-layouts')) {
  customElements.define('pp-hangtiles-layouts', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.data = JSON.parse(this.querySelector('[data-hangtiles-data]').textContent);
      this.addEventListener('change', () => this.update(), {signal});
      this.querySelector('[data-continue]').addEventListener('click', event => {
        if (event.currentTarget.getAttribute('aria-disabled') === 'true') event.preventDefault();
      }, {signal});
      this.addEventListener('shopify:block:select', event => {
        const blockId = event.detail.blockId;
        const input = Array.from(this.querySelectorAll('[data-layout]')).find(el => el.value === blockId);
        if (input) {input.checked = true; this.update();}
        const photo = Array.from(this.querySelectorAll('[data-photo-id]')).find(el => el.dataset.photoId === blockId);
        if (photo && photo.hidden) {
          const largest = Array.from(this.querySelectorAll('[data-layout]')).sort((a,b)=>Number(b.dataset.count)-Number(a.dataset.count))[0];
          if (largest) {largest.checked = true; this.update();}
        }
      }, {signal});
      this.update();
      this.dataset.ready = 'true';
    }
    disconnectedCallback() {this.controller?.abort(); this.controller = null;}
    text(key, values) {return this.data.labels[key].replace(/\[(\w+)\]/g, (match,k)=>values[k] ?? match);}
    update() {
      const layout = this.querySelector('[data-layout]:checked');
      const colour = this.querySelector('[data-frame-choice]:checked').value;
      if (!layout) return;
      const count = Number(layout.dataset.count), columns = Number(layout.dataset.columns), rows = Math.ceil(count / columns);
      const tile = Number(this.dataset.tileSize), gap = Number(this.dataset.gap);
      const width = columns * tile + (columns - 1) * gap, height = rows * tile + (rows - 1) * gap;
      const gallery = this.querySelector('.ht-gallery'), grid = this.querySelector('.ht-photo-grid');
      gallery.style.width = `${width / Number(this.dataset.wallWidth) * 100}%`;
      gallery.style.setProperty('--cols', columns);
      grid.style.columnGap = `${gap / width * 100}%`; grid.style.rowGap = `${gap / height * 100}%`;
      grid.style.aspectRatio = `${width} / ${height}`;
      const originalTiles = Array.from(grid.querySelectorAll('[data-photo-id]'));
      grid.querySelectorAll('[data-clone]').forEach(el => el.remove());
      originalTiles.forEach((el, i) => {el.hidden = i >= count;});
      if (originalTiles.length) for (let i=originalTiles.length; i<count; i++) {
        const clone=originalTiles[i % originalTiles.length].cloneNode(true);
        clone.removeAttribute('data-photo-id'); clone.removeAttribute('data-shopify-editor-block'); clone.dataset.clone='true'; clone.hidden=false; grid.append(clone);
      }
      this.querySelector('.ht-room').dataset.frame = colour;
      const colourLabel = this.data.labels[colour];
      gallery.setAttribute('aria-label', this.text('description', {count, colour:colourLabel, columns, rows}));
      this.querySelector('[data-room-title]').textContent = layout.dataset.title;
      this.querySelector('[data-width]').textContent = `${width} cm`;
      this.querySelector('[data-footprint]').textContent = this.text('footprint', {width,height});
      this.querySelector('[data-set-description]').textContent = this.text('selection', {count, colour:colourLabel});
      const variant=this.data.products[colour].find(v=>v.count===count);
      const available=Boolean(variant?.available), link=this.querySelector('[data-continue]');
      this.querySelector('[data-price]').textContent=available ? variant.price : '';
      this.querySelector('[data-unit-price]').textContent=variant ? this.text('perTile', {price:variant.unitPrice}) : '';
      this.querySelector('[data-cta-label]').textContent=available ? this.data.labels.cta : this.data.labels.unavailable;
      if(available){link.href=variant.url;link.removeAttribute('aria-disabled');}else{link.removeAttribute('href');link.setAttribute('aria-disabled','true');}
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-menu-preview"]) return;
  try {
    
(() => {
  function init() {
    const root = document.getElementById('pp-navigation-preview');
    if (!root || root.dataset.bound) return;
    root.dataset.bound = 'true';
    const header = root.querySelector('.ppnav-header');
    function measureHeader() {
      if (!root.isConnected) return;
      const headerHeight = header.getBoundingClientRect().height.toFixed(2) + 'px';
      const toolbarHeight = '0px';
      document.documentElement.style.setProperty('--ppnav-header-height', headerHeight);
      document.documentElement.style.setProperty('--ppnav-toolbar-height', toolbarHeight);
      document.documentElement.style.setProperty('--header-height', headerHeight);
    }
    const headerResize = new ResizeObserver(measureHeader);
    headerResize.observe(header);
    measureHeader();
    root.classList.toggle('ppnav-scrolled', window.scrollY > 10);
    const scrollTracker = document.getElementById('header-scroll-tracker');
    const scrollObserver = scrollTracker ? new IntersectionObserver(entries => {
      root.classList.toggle('ppnav-scrolled', !entries[0].isIntersecting);
    }) : null;
    if (scrollObserver) scrollObserver.observe(scrollTracker);
    document.addEventListener('shopify:section:unload', function cleanup(event) {
      if (!event.target.contains(root)) return;
      headerResize.disconnect();
      if (scrollObserver) scrollObserver.disconnect();
      document.removeEventListener('shopify:section:unload', cleanup);
    });

    const menus = Array.from(root.querySelectorAll('.ppnav-dropdown'));
    const mobile = root.querySelector('#ppnav-mobile');
    const search = root.querySelector('#ppnav-search');
    const mobileNav = mobile.querySelector('nav');
    const mobileSearchToggle = mobile.querySelector('[data-ppnav-mobile-search-toggle]');
    const mobileSearchForm = mobile.querySelector('#ppnav-mobile-search-form');
    const mobileSearchInput = mobileSearchForm.querySelector('input[type="search"]');
    let mobileScrollFrame;
    function setMobileSearch(open, restoreFocus = false) {
      mobileSearchForm.hidden = !open;
      mobileSearchToggle.setAttribute('aria-expanded', String(open));
      if (open) mobileSearchInput.focus({ preventScroll: true });
      else if (restoreFocus) mobileSearchToggle.focus({ preventScroll: true });
    }
    mobileSearchToggle.addEventListener('click', () => setMobileSearch(mobileSearchForm.hidden));
    mobile.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !mobileSearchForm.hidden) {
        event.preventDefault();
        event.stopPropagation();
        setMobileSearch(false, true);
      }
    });
    mobile.addEventListener('close', () => {
      setMobileSearch(false);
      cancelAnimationFrame(mobileScrollFrame);
    });
    mobileNav.querySelectorAll('.ppnav-mobile-details').forEach(detail => {
      detail.addEventListener('toggle', () => {
        if (!detail.open || !mobile.open) return;
        Array.from(detail.parentElement.children).forEach(sibling => {
          if (sibling !== detail && sibling.matches('details.ppnav-mobile-details')) sibling.open = false;
        });
        cancelAnimationFrame(mobileScrollFrame);
        mobileScrollFrame = requestAnimationFrame(() => {
          mobileScrollFrame = requestAnimationFrame(() => {
            if (!detail.open || !mobile.open) return;
            const heading = detail.querySelector('summary');
            const top = mobileNav.scrollTop + heading.getBoundingClientRect().top - mobileNav.getBoundingClientRect().top;
            mobileNav.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
          });
        });
      });
    });
    let mask;
    let lastTrigger;
    let hoverTimer;
    function closeMenus(except) {
      menus.forEach(menu => { if (menu !== except) menu.open = false; });
      if (!menus.some(menu => menu.open) && mask) { mask.remove(); mask = null; }
    }
    function syncMask() {
      if (menus.some(menu => menu.open)) {
        if (!mask) {
          mask = document.createElement('button');
          mask.className = 'ppnav-mask';
          mask.setAttribute('aria-label', root.dataset.closeLabel);
          mask.addEventListener('click', () => closeMenus());
          document.body.appendChild(mask);
        }
      } else if (mask) { mask.remove(); mask = null; }
    }
    menus.forEach(menu => {
      menu.addEventListener('toggle', () => {
        const summary = menu.querySelector('summary');
        summary.setAttribute('aria-expanded', String(menu.open));
        if (menu.open) closeMenus(menu);
        syncMask();
      });
      menu.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || !matchMedia('(hover:hover) and (min-width:900px)').matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => { closeMenus(menu); menu.open = true; }, 220);
      });
      menu.addEventListener('pointerleave', () => {
        clearTimeout(hoverTimer);
      });
      menu.addEventListener('focusout', () => {
        setTimeout(() => { if (!menu.contains(document.activeElement)) { menu.open = false; syncMask(); } }, 0);
      });
    });
    root.addEventListener('pointerleave', () => {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(() => {
        if (!menus.some(menu => menu.contains(document.activeElement))) closeMenus();
      }, 220);
    });
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menus.some(menu => menu.open)) {
        const current = menus.find(menu => menu.open);
        closeMenus();
        current.querySelector('summary').focus();
      }
    });
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      const destination = new URL(link.href, location.href);
      if (destination.origin !== location.origin || destination.pathname !== location.pathname || destination.hash !== '#compare-canvas-sizes') return;
      clearTimeout(hoverTimer);
      closeMenus();
      if (mobile.open) mobile.close();
    });
    document.addEventListener('click', event => {
      if (!root.contains(event.target)) closeMenus();
    });
    function openDialog(dialog, trigger) {
      clearTimeout(hoverTimer);
      closeMenus();
      [mobile, search].forEach(other => { if (other.open) other.close(); });
      lastTrigger = trigger;
      dialog.showModal();
      if (dialog === search) search.querySelector('input[type="search"]').focus();
    }
    root.querySelectorAll('[data-ppnav-mobile]').forEach(button => button.addEventListener('click', () => openDialog(mobile, button)));
    root.querySelectorAll('[data-ppnav-search]').forEach(button => button.addEventListener('click', () => openDialog(search, button)));
    root.querySelectorAll('[data-ppnav-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
    [mobile, search].forEach(dialog => {
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (![mobile, search].some(other => other.open) && lastTrigger?.isConnected) {
          if (lastTrigger.closest('dialog') && !lastTrigger.closest('dialog').open) {
            root.querySelector('.ppnav-mobile-trigger').focus();
          } else lastTrigger.focus({ preventScroll: true });
        }
      });
    });
    matchMedia('(max-width:899px)').addEventListener('change', event => {
      clearTimeout(hoverTimer);
      closeMenus();
      if (!event.matches && mobile.open) {
        lastTrigger = root.querySelector('.ppnav-logo');
        mobile.close();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-premium-closing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-premium-closing')) {
  customElements.define('pp-premium-closing', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.button = this.querySelector('.mobile-cta');
      const update = () => {
        const hero = document.querySelector('.pp-premium .hero');
        const finishes = document.querySelector('.pp-premium .finishes');
        const final = this.querySelector('.final-cta');
        if (!hero || !finishes || !final) {this.button.hidden = true; return;}
        const f = finishes.getBoundingClientRect();
        this.button.hidden = innerWidth > 680 || hero.getBoundingClientRect().bottom > 0 || (f.top < innerHeight && f.bottom > 0) || final.getBoundingClientRect().top < innerHeight;
      };
      this.observer = new IntersectionObserver(update);
      document.querySelectorAll('.pp-premium .hero, .pp-premium .finishes, .pp-premium .final-cta').forEach(e => this.observer.observe(e));
      window.addEventListener('resize', update, {passive:true,signal:this.events.signal});
      update();
    }
    disconnectedCallback() {this.observer?.disconnect();this.events?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-premium-finishes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-premium-finishes')) {
  customElements.define('pp-premium-finishes', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-premium-open]');
        if (trigger && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
          const dialog = this.querySelector('#' + CSS.escape(trigger.dataset.premiumOpen));
          if (dialog && typeof dialog.showModal === 'function') {
            event.preventDefault(); this.returnFocus = trigger; dialog.showModal();
          }
        }
        if (event.target.closest('.dialog-close')) event.target.closest('dialog').close();
        if (event.target instanceof HTMLDialogElement) {
          const r = event.target.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) event.target.close();
        }
      }, {signal:this.events.signal});
      this.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('close', () => this.returnFocus?.focus({preventScroll:true}), {signal:this.events.signal}));
    }
    disconnectedCallback() { this.querySelectorAll('dialog[open]').forEach(d => d.close()); this.events?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-premium-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-premium-studio')) {
  customElements.define('pp-premium-studio', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-stage]');
        if (!button) return;
        this.querySelectorAll('[data-stage]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        this.querySelectorAll('[data-scene]').forEach(s => s.hidden = s.dataset.scene !== button.dataset.stage);
      }, {signal:this.events.signal});
    }
    disconnectedCallback() {this.events?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-product-sections"] && !Shopify.designMode) return;
  try {
    

(() => {
  function init(root) {
    if(root.dataset.ready)return;
    root.dataset.ready='true';root.classList.add('is-enhanced');
    root.querySelectorAll('[data-detail-section]').forEach(section=>{
      const panels=[...section.querySelectorAll('.impact-panel')];
      const buttons=[...section.querySelectorAll('[data-detail]')];
      const show=index=>{panels.forEach((p,i)=>{p.hidden=i!==index;p.classList.toggle('is-changed',i===index)});buttons.forEach(b=>b.setAttribute('aria-pressed',String(+b.dataset.detail===index)));section.querySelector('.impact-stage').dataset.focus=index;};
      buttons.forEach(b=>b.addEventListener('click',()=>show(+b.dataset.detail)));
      const nav=[...section.querySelectorAll('.impact-controls button')];
      nav.forEach((b,i)=>b.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const n=e.key==='Home'?0:e.key==='End'?nav.length-1:(i+(e.key==='ArrowRight'?1:nav.length-1))%nav.length;nav[n].focus();show(n)}));show(0);
    });
    root.querySelectorAll('[data-room-section]').forEach(section=>{
      section.querySelectorAll('[data-size]').forEach(button=>button.addEventListener('click',()=>{
        const w=Number(button.dataset.width),h=Number(button.dataset.height),c=Number(button.dataset.console);
        if(!(w>0&&h>0&&c>0))return;
        const art=section.querySelector('[data-wall-print]');art.style.width=`${Math.min(w/c*92,95)}%`;art.style.aspectRatio=`${w}/${h}`;
        section.querySelector('[data-width-label]').textContent=`${w} cm`;
        section.querySelector('[data-size-note]').textContent=button.dataset.note;
        section.querySelector('[data-size-price]').textContent=button.dataset.price;
        section.querySelectorAll('[data-size]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      }));
      section.querySelector('[data-return]').addEventListener('click',()=>{
        const target=document.querySelector('variant-picker')||document.querySelector('form[action*="/cart/add"]');
        if(target){target.scrollIntoView({behavior:'auto',block:'center'});const focus=target.querySelector('input:not([type=hidden]),select,button');if(focus)focus.focus({preventScroll:true});}
      });
    });
    const dialog=root.querySelector('dialog');
    root.querySelectorAll('[data-enlarge]').forEach(link=>link.addEventListener('click',e=>{
      if(!dialog.showModal)return;e.preventDefault();
      const img=dialog.querySelector('[data-dialog-image]');img.src=link.href;img.alt=link.dataset.title;
      dialog.querySelector('[data-dialog-title]').textContent=link.dataset.title;
      dialog.querySelector('[data-dialog-caption]').textContent=link.dataset.caption;dialog.showModal();
    }));
    dialog.querySelector('[data-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',e=>{if(e.target!==dialog)return;const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()});
  }
  const scan=()=>document.querySelectorAll('[data-pp-sections]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  document.addEventListener('shopify:section:load',scan);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-start-here-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialiseGuide(scope) {
      scope.querySelectorAll('[data-guide-calculator]').forEach((form) => {
        if (form.dataset.ready) return;
        form.dataset.ready = 'true';
        const width = form.elements.width;
        const height = form.elements.height;
        const result = form.querySelector('[data-guide-result]');
        const error = form.querySelector('[data-guide-error]');
        const links = form.querySelectorAll('[data-guide-match]');
        function clearResult() { result.hidden = true; error.hidden = true; width.removeAttribute('aria-invalid'); height.removeAttribute('aria-invalid'); }
        width.addEventListener('input', clearResult);
        height.addEventListener('input', clearResult);
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const w = Number(width.value), h = Number(height.value);
          const validWidth = Number.isSafeInteger(w) && w > 0;
          const validHeight = Number.isSafeInteger(h) && h > 0;
          if (!validWidth || !validHeight) {
            result.hidden = true; error.hidden = false;
            width.setAttribute('aria-invalid', String(!validWidth)); height.setAttribute('aria-invalid', String(!validHeight));
            (!validWidth ? width : height).focus(); return;
          }
          error.hidden = true;
          const inchesWidth = Math.round(w / 110), inchesHeight = Math.round(h / 110);
          form.querySelector('[data-guide-inches]').textContent = inchesWidth + ' × ' + inchesHeight;
          form.querySelector('[data-guide-cm]').textContent = Math.round(inchesWidth * 2.54) + ' × ' + Math.round(inchesHeight * 2.54);
          const ratio = Math.max(w,h) / Math.min(w,h);
          let shape = 'square';
          if (ratio > 7 / 6) shape = 'standard';
          if (ratio > 13 / 6) shape = 'panoramic';
          if (ratio > 3.8) shape = 'ultra';
          links.forEach((link) => { link.hidden = link.dataset.guideMatch !== shape; });
          result.hidden = false;
        });
      });
    }
    initialiseGuide(document);
    document.addEventListener('shopify:section:load', (event) => initialiseGuide(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-studio-crop"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pp-studio-crop')){
 customElements.define('pp-studio-crop',class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;this.abort=new AbortController();const o={signal:this.abort.signal};
   this.buttons=[...this.querySelectorAll('[data-crop]')];this.active=this.buttons[0];
   this.addEventListener('click',e=>{const b=e.target.closest('[data-crop]');if(b){this.active=b;this.render();}},o);
   this.querySelector('.crop-image img')?.addEventListener('load',()=>this.render(),o);
   document.addEventListener('shopify:block:select',e=>{const b=this.buttons.find(el=>el.dataset.block===e.detail.blockId);if(b){this.active=b;this.render();}},o);
   this.render();
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;}
  render(){
   if(!this.active)return;
   const img=this.querySelector('.crop-image img');if(!img)return;
   const source=(img.naturalWidth||Number(img.getAttribute('width')))/(img.naturalHeight||Number(img.getAttribute('height')));
   const shape=this.active.dataset.crop;
   const ratio={panoramic:3,landscape:1.5,square:1,portrait:2/3}[shape]||source;
   const w=Math.min(100,100*ratio/source),h=Math.min(100,100*source/ratio);
   const box=this.querySelector('.crop-window');Object.assign(box.style,{left:`${(100-w)/2}%`,top:`${(100-h)/2}%`,bottom:'auto',width:`${w}%`,height:`${h}%`});
   this.buttons.forEach(b=>{b.classList.toggle('selected',b===this.active);b.setAttribute('aria-pressed',String(b===this.active));});
   this.querySelectorAll('[data-explanation]').forEach(p=>p.hidden=p.dataset.explanation!==this.active.dataset.block);
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-studio-editing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-guide-editing')) {
  customElements.define('pp-guide-editing', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.current = 'after';
      this.dialog = this.querySelector('dialog');
      this.querySelector('[data-edit-controls]').hidden = false;
      this.querySelector('[data-edit-enlarge]').hidden = !this.dialog.showModal;
      this.addEventListener('click', event => {
        const view = event.target.closest('[data-edit-view]');
        if (view) {
          this.current = view.dataset.editView;
          this.querySelectorAll('[data-edit-view]').forEach(button => button.setAttribute('aria-pressed', String(button === view)));
          this.querySelectorAll('[data-edit-image]').forEach(panel => panel.hidden = panel.dataset.editImage !== this.current);
          this.querySelectorAll('[data-edit-caption]').forEach(panel => panel.hidden = panel.dataset.editCaption !== this.current);
        }
        if (event.target.closest('[data-edit-enlarge]')) {
          const source = this.querySelector(`[data-edit-image="${this.current}"] img`);
          if (!source) return;
          this.returnFocus = event.target.closest('button');
          const image = source.cloneNode(true);
          image.loading = 'eager';
          image.sizes = '100vw';
          this.querySelector('[data-edit-large]').replaceChildren(image);
          this.dialog.showModal();
          document.documentElement.classList.add('pp-guide-editor-open');
        }
        if (event.target.closest('[data-edit-close]') || event.target === this.dialog) this.dialog.close();
      }, {signal:this.abort.signal});
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('pp-guide-editor-open');
        this.querySelector('[data-edit-large]').replaceChildren();
        this.returnFocus?.focus({preventScroll:true});
      }, {signal:this.abort.signal});
    }
    disconnectedCallback() {
      this.dialog?.close();
      document.documentElement.classList.remove('pp-guide-editor-open');
      this.abort?.abort();this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-studio-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-guide-video')) {
  customElements.define('pp-guide-video', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.dialog = this.querySelector('dialog');
      this.video = this.querySelector('video');
      this.trigger = this.querySelector('[data-guide-watch]');
      this.addEventListener('click', event => {
        if (event.target.closest('[data-guide-watch]') && this.dialog.showModal) {
          event.preventDefault();
          this.querySelector('[data-guide-error]').hidden = true;
          this.video.src = this.video.dataset.src;
          if (this.video.dataset.poster) this.video.poster = this.video.dataset.poster;
          this.dialog.showModal();
          document.documentElement.classList.add('pp-guide-video-open');
          this.video.play().catch(() => {});
        }
        if (event.target.closest('[data-guide-close]') || event.target === this.dialog) this.dialog.close();
      }, {signal:this.abort.signal});
      this.video.addEventListener('error', () => this.querySelector('[data-guide-error]').hidden = false, {signal:this.abort.signal});
      this.dialog.addEventListener('close', () => {
        this.video.pause();this.video.removeAttribute('src');this.video.removeAttribute('poster');this.video.load();
        document.documentElement.classList.remove('pp-guide-video-open');
        this.trigger.focus({preventScroll:true});
      }, {signal:this.abort.signal});
    }
    disconnectedCallback() {
      this.dialog?.close();this.video?.pause();
      document.documentElement.classList.remove('pp-guide-video-open');
      this.abort?.abort();this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-studio-walkthrough"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-studio-walkthrough')) {
 customElements.define('pp-studio-walkthrough', class extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.abort = new AbortController();
   const options = {signal:this.abort.signal};
   this.steps = [...this.querySelectorAll('[data-step]')];
   this.current = 0;
   this.device = matchMedia('(max-width:760px)').matches ? 'mobile' : 'desktop';
   this.addEventListener('click', e => {
    const summary = e.target.closest('.step summary');
    if (summary) {e.preventDefault();this.select(Number(summary.parentElement.dataset.step));return;}
    const tab=e.target.closest('[data-guide-step]');
    if(tab)this.select(Number(tab.dataset.guideStep));
    const device=e.target.closest('[data-device]');
    if(device){this.device=device.dataset.device;this.render();}
    if(e.target.closest('[data-next]'))this.select(this.current+1);
    if(e.target.closest('[data-previous]'))this.select(this.current-1);
   },options);
   document.addEventListener('shopify:block:select',e=>{const i=this.steps.findIndex(el=>el.dataset.block===e.detail.blockId);if(i>=0)this.select(i);},options);
   this.classList.add('guide-ready');this.render();
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;}
  select(i){this.current=Math.max(0,Math.min(this.steps.length-1,i));this.render();}
  render(){
   this.dataset.deviceView=this.device;
   this.steps.forEach((el,i)=>el.open=i===this.current);
   this.querySelectorAll('[data-scene]').forEach(el=>el.hidden=Number(el.dataset.scene)!==this.current);
   this.querySelector('[data-number]').textContent=`${this.current+1} / ${this.steps.length}`;
   this.querySelector('[data-caption]').textContent=this.querySelector(`[data-caption-source="${this.current}"]`)?.content.textContent||'';
   this.querySelector('[data-previous]').disabled=this.current===0;
   this.querySelector('[data-next]').disabled=this.current>=this.steps.length-1;
   this.querySelectorAll('[data-guide-step]').forEach(el=>el.setAttribute('aria-pressed',String(Number(el.dataset.guideStep)===this.current)));
   this.querySelectorAll('[data-device]').forEach(el=>{const active=el.dataset.device===this.device;el.classList.toggle('selected',active);el.setAttribute('aria-pressed',String(active));});
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-sunlit-hero"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('pp-sunlit-hero')){
    customElements.define('pp-sunlit-hero',class extends HTMLElement{
      connectedCallback(){
        if(this.controller)return;
        this.controller=new AbortController();const signal=this.controller.signal;
        for(const name of ['stage','object','photo','canvas','frame','shadow','surface','room','ambient','copy','controls','progress','play','skip'])this[name]=this.querySelector(`.ppsl-${name}`);
        this.chapters=[...this.querySelectorAll('[data-progress]')];this.p=0;this.target=0;this.playing=false;this.raf=0;this.chapter=-1;this.visible=true;
        this.preference=matchMedia('(prefers-reduced-motion: reduce), (max-height: 540px)');
        this.preference.addEventListener('change',()=>this.configure(),{signal});
        this.onScroll=()=>{if(!this.active)return;this.syncStart();this.target=this.clamp((scrollY-this.start)/this.distance);if(this.visible)this.wake();else{this.p=this.target;this.render()}};
        window.addEventListener('scroll',this.onScroll,{signal,passive:true});
        this.stop=()=>{this.playing=false;if(this.play)this.play.textContent=this.p>.99?this.dataset.replay:this.dataset.watch;this.dataset.playing='false'};
        window.addEventListener('wheel',this.stop,{signal,passive:true});
        window.addEventListener('touchstart',e=>{if(!e.target.closest('button,a,input'))this.stop()},{signal,passive:true});
        window.addEventListener('keydown',e=>{if(['PageDown','PageUp','ArrowDown','ArrowUp','Home','End','Escape',' '].includes(e.key))this.stop()},{signal});
        this.querySelectorAll('a').forEach(a=>a.addEventListener('click',this.stop,{signal}));
        this.play.addEventListener('click',()=>{if(this.playing){this.stop();return}if(this.p>.98){this.seek(0);this.p=0;this.render()}this.playing=true;this.dataset.playing='true';this.play.textContent=this.dataset.pause;this.wake()},{signal});
        this.progress.addEventListener('input',()=>{this.stop();this.seek(Number(this.progress.value)/1000)},{signal});
        this.chapters.forEach(b=>b.addEventListener('click',()=>{this.stop();this.seek(Number(b.dataset.progress))},{signal}));
        this.skip.addEventListener('click',()=>{this.stop();const next=this.closest('.shopify-section')?.nextElementSibling||this.nextElementSibling;if(next){next.scrollIntoView({behavior:'instant',block:'start'});if(!next.hasAttribute('tabindex'))next.setAttribute('tabindex','-1');next.focus({preventScroll:true})}},{signal});
        document.addEventListener('visibilitychange',()=>{if(document.hidden){this.stop();cancelAnimationFrame(this.raf);this.raf=0}else this.onScroll()},{signal});
        this.resize=new ResizeObserver(()=>this.measure());this.resize.observe(this.stage);this.resize.observe(this.copy);
        this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(!this.visible){this.stop();cancelAnimationFrame(this.raf);this.raf=0}else this.onScroll()});this.observer.observe(this);
        this.configure();document.fonts?.ready.then(()=>{if(this.isConnected)this.measure()});
      }
      disconnectedCallback(){this.controller?.abort();this.resize?.disconnect();this.observer?.disconnect();cancelAnimationFrame(this.raf);this.raf=0;this.controller=null}
      clamp(n){return Math.max(0,Math.min(1,n))}
      mix(a,b,t){return a+(b-a)*t}
      ease(t){t=this.clamp(t);return t*t*t*(t*(6*t-15)+10)}
      curve(t,points){const n=points.length;if(t<=points[0][0])return points[0][1];if(t>=points[n-1][0])return points[n-1][1];const slopes=points.slice(1).map((p,i)=>(p[1]-points[i][1])/(p[0]-points[i][0]));const m=points.map((_,i)=>{if(!i||i===n-1)return 0;const a=slopes[i-1],b=slopes[i];return a*b<=0?0:2*a*b/(a+b)});let i=0;while(t>points[i+1][0])i++;const h=points[i+1][0]-points[i][0],u=(t-points[i][0])/h;return(2*u*u*u-3*u*u+1)*points[i][1]+(u*u*u-2*u*u+u)*h*m[i]+(-2*u*u*u+3*u*u)*points[i+1][1]+(u*u*u-u*u)*h*m[i+1]}
      configure(){
        this.active=this.dataset.motion==='true'&&!this.preference.matches;
        this.stop();cancelAnimationFrame(this.raf);this.raf=0;this.controls.hidden=!this.active;
        this.classList.toggle('ppsl-ready',this.active);
        if(this.active)this.measure();else{this.p=0;this.target=0;[this.object,this.photo,this.frame,this.shadow,this.surface,this.room,this.ambient].forEach(el=>el.removeAttribute('style'));this.dataset.progress='0.0000'}
      }
      measure(){
        if(!this.active)return;
        const rect=this.stage.getBoundingClientRect(),w=rect.width,h=rect.height;if(!w||!h)return;
        const mobile=w<750,copyTop=this.copy.offsetTop,base=Math.min(w*.88,1120),unit=base/1850,inner=1816*unit,outerH=(1816/3+34)*unit;
        const roomW=mobile?w*1.4:Math.min(Math.max(w,h*1672/941),w*1.4),roomH=roomW*941/1672;
        const span=(Number(this.dataset.artSpan)||54.7)/100,artX=(Number(this.dataset.artX)||50)/100,artY=(Number(this.dataset.artY)||34.5)/100;
        const end=roomW*span/base,halfH=outerH*end/2,roomTop=mobile?Math.min(h*.18,copyTop-28-roomH*artY-halfH):(h-roomH)/2;
        const finalX=(artX-.5)*roomW,finalY=roomTop+artY*roomH-h/2,cover=Math.max(w,h*3)*1.004,start=cover/inner,focus=(parseFloat(getComputedStyle(this).getPropertyValue('--ppsl-focal'))||40)/100;
        this.geometry={w,h,mobile,base,unit,inner,outerH,roomW,roomH,roomTop,end,finalX,finalY,start,startX:(w-cover)*(focus-.5),mid:Math.max(end*1.07,w*(mobile?.86:.66)/base),middleY:Math.min(h*.32,copyTop-30-halfH)-h/2};
        this.object.style.width=`${base}px`;this.object.style.height=`${outerH}px`;
        for(const [key,value] of Object.entries({inset:17*unit,face:12*unit,'gap-width':5*unit,depth:53*unit,recess:3*unit,edge:.6*unit}))this.object.style.setProperty(`--ppsl-${key}`,`${value}px`);
        this.object.style.setProperty('--ppsl-contact-shadow',`${2*unit}px ${3*unit}px ${7*unit}px #0005`);
        this.object.style.setProperty('--ppsl-cast-shadow',`${18*unit}px ${12*unit}px ${28*unit}px #211b1433`);
        Object.assign(this.room.style,{width:`${roomW}px`,height:`${roomH}px`,left:`${(w-roomW)/2}px`,top:`${roomTop}px`});
        const top=parseFloat(getComputedStyle(this.stage).top)||0;this.start=this.getBoundingClientRect().top+scrollY-top;this.distance=Math.max(1,this.offsetHeight-h);
        this.onScroll();this.render();
      }
      syncStart(){this.start=this.getBoundingClientRect().top+scrollY-(parseFloat(getComputedStyle(this.stage).top)||0)}
      seek(p){if(!this.active)return;this.syncStart();this.target=this.clamp(p);window.scrollTo({top:this.start+this.distance*this.target,behavior:'instant'});this.wake()}
      wake(){if(!this.raf&&!document.hidden){this.last=performance.now();this.raf=requestAnimationFrame(t=>this.tick(t))}}
      tick(t){this.raf=0;if(!this.active||document.hidden)return;const dt=Math.min(.05,Math.max(0,(t-this.last)/1000));this.last=t;if(this.playing){this.target=this.clamp(this.target+dt/9);window.scrollTo({top:this.start+this.distance*this.target,behavior:'instant'});if(this.target>=1)this.stop()}this.p=this.mix(this.p,this.target,1-Math.exp(-dt/.16));if(Math.abs(this.p-this.target)<.0001)this.p=this.target;this.render();if(this.playing||Math.abs(this.p-this.target)>.0001)this.raf=requestAnimationFrame(time=>this.tick(time))}
      pose(p){
        const g=this.geometry;
        return{scale:Math.exp(this.curve(p,[[0,Math.log(g.start)],[.07,Math.log(g.start*.998)],[.5,Math.log(g.mid*1.04)],[.68,Math.log(g.mid)],[1,Math.log(g.end)]])),x:this.curve(p,[[0,g.startX],[.42,g.w*.012],[.68,g.w*.008],[1,g.finalX]]),y:this.curve(p,[[0,0],[.1,0],[.5,g.middleY],[.68,g.middleY],[1,g.finalY]]),rx:this.curve(p,[[0,0],[.18,0],[.46,-5],[.66,-3],[1,0]]),ry:this.curve(p,[[0,0],[.16,0],[.46,14],[.68,8],[1,0]]),rz:this.curve(p,[[0,0],[.45,1],[.7,.4],[1,0]]),material:this.ease((p-.12)/.42),frame:this.ease((p-.10)/.21),room:this.ease((p-.56)/.40),ambient:this.ease((p-.09)/.35)};
      }
      render(){
        if(!this.geometry||!this.active)return;const p=this.p,a=this.pose(p);
        this.object.style.transform=`translate(-50%,-50%) translate3d(${a.x}px,${a.y}px,0) rotateX(${a.rx}deg) rotateY(${a.ry}deg) rotateZ(${a.rz}deg) scale(${a.scale})`;
        this.frame.style.opacity=a.frame;this.shadow.style.opacity=a.room;this.room.style.opacity=a.room;this.ambient.style.opacity=a.ambient;
        this.photo.style.filter=`brightness(${this.mix(1,.79,a.material)}) saturate(${this.mix(1,.87,a.material)}) contrast(${this.mix(1,.97,a.material)})`;
        this.surface.style.opacity=a.material;this.progress.value=Math.round((document.activeElement===this.progress?this.target:p)*1000);
        const chapter=p<.32?0:p<.84?1:2;if(chapter!==this.chapter){this.chapter=chapter;this.chapters.forEach((b,i)=>i===chapter?b.setAttribute('aria-current','step'):b.removeAttribute('aria-current'));this.progress.setAttribute('aria-valuetext',this.chapters[chapter].textContent.trim())}
        this.dataset.progress=p.toFixed(4);if(!this.playing){const label=p>.99?this.dataset.replay:this.dataset.watch;if(this.play.textContent!==label)this.play.textContent=label}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-wedding-choices"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-wedding-extra-choices')) {
    class WeddingExtraChoices extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('[data-group-toggle]');
        this.panel = this.querySelector('[data-group-panel]');
        this.staticTitle = this.querySelector('[data-static-title]');
        if (!this.toggleButton || !this.panel || !this.staticTitle) return;
        this.mobileExpanded = false;
        this.mediaQuery = window.matchMedia('(max-width: 699px)');
        this.syncLayout = () => {
          const mobile = this.mediaQuery.matches;
          this.toggleButton.hidden = !mobile;
          this.staticTitle.hidden = mobile;
          this.panel.hidden = mobile && !this.mobileExpanded;
          this.toggleButton.setAttribute('aria-expanded', String(!this.panel.hidden));
        };
        this.toggleGroup = () => {
          this.mobileExpanded = !this.mobileExpanded;
          this.syncLayout();
        };
        this.revealBlock = () => {
          this.mobileExpanded = true;
          this.syncLayout();
        };
        this.toggleButton.addEventListener('click', this.toggleGroup);
        this.mediaQuery.addEventListener('change', this.syncLayout);
        this.addEventListener('shopify:block:select', this.revealBlock);
        this.syncLayout();
      }
      disconnectedCallback() {
        this.toggleButton?.removeEventListener('click', this.toggleGroup);
        this.mediaQuery?.removeEventListener('change', this.syncLayout);
        this.removeEventListener('shopify:block:select', this.revealBlock);
      }
    }
    customElements.define('pp-wedding-extra-choices', WeddingExtraChoices);
  }

  } catch(e) { console.error(e); }
})();
})();
